import { Button } from '@design-system/button';
import { Icon } from '@design-system/icon';
import clsx from 'classnames';
import { navigate } from 'gatsby';
import React from 'react';

import { useBrowserScreen } from '~/components/ExtendedGlobalHeader/hooks/useBrowserScreen';

export type ProductsCtaProps = {
  heading: string;
  description: string;
  url: string;
  ctaLabel: string;
  className?: string;
};
const ProductsCta: React.FC<ProductsCtaProps> = ({
  heading,
  description,
  url,
  ctaLabel,
  className = '',
}) => {
  const { isDesktopView } = useBrowserScreen();
  const handleButtonClick = () => {
    if (!url) {
      return;
    }
    // Check if it's an external link
    if (/^https?:\/\//.test(url)) {
      window.location.href = url;

      return;
    }

    // Use Gatsby navigate for internal links
    navigate(url);
  };

  return (
    <section
      className={clsx('pcta', { 'pcta--isMobile': !isDesktopView }, className)}
    >
      <h3 className="pcta__heading">{heading}</h3>
      <p
        className={clsx('pcta__desc', {
          'pcta__desc--isMobile': !isDesktopView,
        })}
      >
        {description}
      </p>

      <Button
        aria-label={ctaLabel}
        className="pcta__button"
        onClick={handleButtonClick}
      >
        <div>
          {!isDesktopView && (
            <span className="pcta__button--icon" aria-hidden="true">
              <Icon size={15} icon="arrowRight" />
            </span>
          )}
          <span>{ctaLabel}</span>
        </div>
      </Button>
    </section>
  );
};

export default ProductsCta;
